export default __webpack_public_path__ + "static/Plots0037-95789b562e9ad66da852842bbbc07e74.jpg";